import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';
import { FertilizerProductId } from 'services/fertilizerProducts/types';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectProductSMgCa } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: FertilizerProductId;
}

type Props = OwnProps;

export default function ProductSMgCaTableCell(
    props: Props
): React.ReactElement {
    const sMgCa = useSelector((state: AppState) =>
        makeSelectProductSMgCa()(state, props)
    );

    return <TableCell>{sMgCa}</TableCell>;
}
